import { FormEditor } from './../../models/editors/form-editor.base.model';

export class FieldsRow extends FormEditor<string> {
    controlType = 'fields-row';

    constructor(options: any = {}) {
        super(options);
    }
}
